import dates from 'frontcore/utils/dates'
import {
  ALERT_DETAILS_ROUTE_NAME,
  DAILY_ROUND_WEEKLY_ROUTE_NAME,
  GEMBA_WALK_ACTIVITIES_DETAILS_ROUTE_NAME,
  HSE_RISKS_DETAILS_ROUTE_NAME,
  IMPROVEMENT_IDEAS_DETAILS_ROUTE_NAME,
  LINE_BOARD_KPI_CARD_DETAILS_NAME,
  OK_FIRST_PART_ASSESSMENT_DETAILS_ROUTE_NAME,
  SFM_KPI_CARD_DETAILS_NAME,
} from 'frontend/routes/constants'

export const MAX_INT_VALUE = 2147483647

export const VALUES_LENGTH = 1
export const DEFAULT_NUMBER_OF_MEASURES = 1

export const VT_STANDARD_SOURCE = 0
export const VS_STANDARD_SOURCE = 1

export const ORDER_SEQUENCES = 0
export const CHOOSE_DESCRIPTIONS = 1
export const CHOOSE_ANNOTATIONS = 2

export const ANNOTATION_MODAL_TYPE = Object.freeze({
  reading: 0, evaluation: 1, checking: 2,
})

export const TOAST_ICONS = {
  error: 'fa fa-exclamation-circle',
  info: 'fa fa-info',
  success: 'fa fa-check',
  warn: 'fa fa-exclamation',
}

export const GREEN_CSS_CLASS = 'color-green'
export const GREY_CSS_CLASS = 'color-grey'
export const NEUTRAL_CSS_CLASS = 'color-neutral'
export const NUMBER_OF_REVIEW_POINTS = 6
export const RED_CSS_CLASS = 'color-red'
export const STATUS_GREEN = 1
export const STATUS_RED = 2
export const WHITE_CSS_CLASS = 'color-white'
export const YELLOW_CSS_CLASS = 'color-yellow'

export const VIRTUAL_TRAINING_PATTERN_LEVEL = 0
export const VISUAL_STANDARD_PATTERN_LEVEL = 0
export const VISUAL_STANDARD_SOURCE = 'standards'

export const ACTION_THROTTLING_DURATION = 300
export const EXTRA_LARGE_TEXT_FIELDS = 900
export const EXTRA_TEXT_LENGTH = 600
export const LARGE_TEXT_FIELDS = 300
export const MEDIUM_TEXT_FIELDS = 100
export const AVERAGE_TEXT_FIELDS = 60
export const SMALL_TEXT_FIELDS = 32
export const TINY_TEXT_FIELDS = 8

export const EMPTY_SELECTOR_OPTION = -1

export const OPERATION_TYPES = Object.freeze({
  none: 0, create: 1, update: 2, delete: 3,
})

export const SHOW_STATUS = Object.freeze({
  create: 'create', update: 'update',
  loading: 'loading', error: 'error',
  result: 'result',
})

export const LAST_CONNECTION_KEY = 'lastConnection'
export const URL_RESPONSE_PREFIX = 'URL_RESPONSE_'
export const Z_INDEX_DEFAULT = 'auto'

export const SHORT_ALPHANUM_FIELD_MAX_LENGTH = 32

export const NOTIFICATION_TIMEOUT = 7000

export const TIME_BEFORE_SEARCH = 450
export const TIME_BEFORE_SAVE = 500

export const IS_IE11 = !!window.MSInputMethodContext && !!document.documentMode
export const IS_FIREFOX = window.InstallTrigger !== undefined

export const BLANK_SPACE = ' '
export const COLON_SEPARATOR = ': '
export const COMMA_SEPARATOR = ', '
export const EMPTY_STRING = ''
export const MINUS_SEPARATOR = '<= '
export const NA = 'NA'
export const PERCENTAGE_CHAR = '%'
export const PLUS_SEPARATOR = '>= '

export const URL_REGEXP_FORMAT = /^((https?):\/\/).{1,50}\.[\w:\d]{1,20}$/


export const PATH_TO_DETAILS = {
  'action': 'actions-details',
  'alerts': ALERT_DETAILS_ROUTE_NAME,
  'aud_cap_log': 'auditcaplog-details',
  'dailyround_cockpit': 'dr-activity-details',
  'dailyround': 'dailyround-details',
  'diagnosis': 'fundamental-detail',
  'sfm': SFM_KPI_CARD_DETAILS_NAME,
  'line_board': LINE_BOARD_KPI_CARD_DETAILS_NAME,
  'fiveS': 'audits-details',
  'hse_audit': 'hseaudit-details',
  'improvement_idea': IMPROVEMENT_IDEAS_DETAILS_ROUTE_NAME,
  'lpa': 'lpa-audits-details',
  'manufacturing_alerts': 'risk-manager-alerts-details',
  'menu_lpa_injection': 'lpainj-details',
  'menu_lpa_paint': 'lpapaint-details',
  'menu_lpa_stock': 'lpastock-details',
  'observation_checklist': 'checklist-details',
  'checklist_audit': 'checklist-details',
  'observation_hestour': 'hestour-details',
  'hestour_audit': 'hestour-details',
  'observation_hse_prod': 'hseproduction-details',
  'hse_prod_audit': 'hseproduction-details',
  'observation_iluo': 'iluo-details',
  'iluo_audit': 'iluo-details',
  'observation_logistics': 'logistics-details',
  'logistics_audit': 'logistics-details',
  'observation_machines': 'machines-details',
  'machines_audit': 'machines-details',
  'observation_qaudits': 'qaudits-details',
  'qaudits_audit': 'qaudits-details',
  'observation_qnn': 'qnn-details',
  'qnn_audit': 'qnn-details',
  'observation_rel': 'rel-details',
  'rel_audit': 'rel-details',
  'observation_shiftchange': 'shiftchange-details',
  'shiftchange_audit': 'shiftchange-details',
  'observation': 'observations-details',
  'ok_first_part': OK_FIRST_PART_ASSESSMENT_DETAILS_ROUTE_NAME,
  'paseo_seguridad': 'observations-details',
  'problem_solving': 'problem-solving-details',
  'self_assessment': 'fundamental-detail',
  'seven_wastes': 'seven-waste-details',
  'standard_work_review': 'swr-evaluation-detail',
  'standards': 'standards-details',
  'standards_audit': 'standards-details',
  'task_manager': 'completed-task-details',
  'dr_weekly_meeting': DAILY_ROUND_WEEKLY_ROUTE_NAME,
  'dr_gemba_walk': GEMBA_WALK_ACTIVITIES_DETAILS_ROUTE_NAME,
  'hse_risk': HSE_RISKS_DETAILS_ROUTE_NAME,

  // LPA Sources

  'assessments_audit': 'assessments_audit-details',
  'audit_fives': 'auditfives-details',
  'audit': 'audit-details',
  'auditfives': 'auditfives-details',
  'cil': 'cil-details',
  'clean_audit': 'clean_audit-details',
  'core_team': 'coreteam-details',
  'eightqb': 'eightqb-details',
  'gemba_walk': 'gemba_walk-details',
  'kamishibai_audit': 'kamishibai_audit-details',
  'lpas': 'lpas-details',
  'maintenance': 'maintenance-details',
  'process': 'process-details',
  'production_start': 'production_start-details',
  'quality_audit': 'quality_audit-details',
  'routes': 'routes-details',
  'security_audit': 'security_audit-details',
  'product_audit': 'product_audit-details',
  'system_audit': 'system_audit-details',
  'production_audit': 'production_audit-details',
}

export const GREATER_THAN = 'gt'
export const GREATER_OR_EQUAL_THAN = 'gte'
export const LESS_THAN = 'lt'
export const LESS_OR_EQUAL_THAN = 'lte'
export const COMPARISON_OPTIONS = [
  {
    'id': LESS_THAN,
    'text': 'common.messages.less_than',
  },
  {
    'id': GREATER_THAN,
    'text': 'common.messages.greater_than',
  },
]

export const MODULE_PERMISSIONS_TYPES = {
  SETTINGS: 0,
  DASHBOARD: 1,
  APPS: 2,
}

export const EMPTY_ACHIEVE_RULE = {
  rule: null,
  target: null,
  target_min: null,
  target_unit: '',
}

export const GRAPH_CHART_TYPES = {
  MONTHLY: 0,
  WEEKLY: 1,
  DAILY: 2,
}

export const ERROR_MSG_MAX_LENGTH = 200

export const SESSION_TIME_UNITS = {
  DAY: 0,
  HOUR: 1,
}

export const PERCENTAGE_SCALE = 'percentage_scale'

export const RANGE_SCALE = 'range_scale'

export const MAX_PERCENTAGE = 100

export const SCALE_TYPES = [{
  value: PERCENTAGE_SCALE,
  label: 'common.messages.percentage_value',
}, {
  value: RANGE_SCALE,
  label: 'common.messages.range',
}]

export const TEMPORALITIES = Object.freeze({
  day: Object.freeze({
    value: 'day',
    int_value: 0,
    frequency: 'daily',
    token_temporality: 'common.messages.day',
    token_frequency: 'common.messages.daily',
    getFromDate: (frequency, quantity, date) => dates.getLastDaysDate((quantity - 1) * -1, date).from,
    getToDate: (frequency, quantity, date) => dates.getLastDaysDate((quantity - 1) * -1, date).to,
  }),
  week: Object.freeze({
    value: 'week',
    int_value: 1,
    frequency: 'weekly',
    token_temporality: 'common.messages.week',
    token_frequency: 'common.messages.weekly',
    getFromDate: (frequency, quantity, date) => dates.getLastWeeksDate((quantity - 1) * -1, date).from,
    getToDate: (frequency, quantity, date) => dates.getLastWeeksDate((quantity - 1) * -1, date).to,
  }),
  month: Object.freeze({
    value: 'month',
    int_value: 2,
    frequency: 'monthly',
    token_temporality: 'common.messages.month',
    token_frequency: 'common.messages.monthly',
    getFromDate: (frequency, quantity, date) => dates.getLastMonthsDates((quantity - 1) * -1, date).from,
    getToDate: (frequency, quantity, date) => dates.getLastMonthsDates((quantity - 1) * -1, date).to,
  }),
  quarter: Object.freeze({
    value: 'quarter',
    int_value: 3,
    frequency: 'quarterly',
    token_temporality: 'common.messages.quarter',
    token_frequency: 'common.messages.quarterly',
    getFromDate: () => {},
    getToDate: () => {},
  }),
  year: Object.freeze({
    value: 'year',
    int_value: 4,
    frequency: 'yearly',
    token_temporality: 'common.messages.year',
    token_frequency: 'common.messages.yearly',
    getFromDate: (frequency, quantity, date) => dates.getUTCDatetimeFromDate(dates.getFirstDayOfYearDate(dates.getYear(date) - (quantity - 1))),
    getToDate: (frequency, quantity, date) => dates.getUTCDatetimeFromDate(dates.getLastDayOfYearDate(dates.getYear(date))),
  }),
})

export const MAX_FREQUENCY_VALUE = 31

export const EMAIL_REGEX = /^[0-9a-zA-Z_\-.]+@[0-9a-zA-Z_\-.]+?\.[a-zA-Z]{2,3}$/
export const ONLY_SPACES_OR_EMPTY_REGEX = /^\s*$/
export const FIELD_TYPES = Object.freeze({ text: 0, bool: 1, people: 2, typology: 3, integer: 4, compound: 5, choice: 6 })
